import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'J’entraîne trois groupes de niveaux très différents et je passais mes dimanches soir à construire mes séances. Avec GYM RYTHMIQUE PRO™, j’ouvre le module de planification, je choisis les exercices et les progressions de chaque groupe, et ma semaine est prête en une demi-heure. J’arrive au gymnase organisée et beaucoup plus sereine.',
  author: 'Camille Duval',
  role: 'Professeure de gymnastique rythmique en club, 38 ans',
  location: 'Lyon, Auvergne-Rhône-Alpes'
}, {
  text: 'La bibliothèque d’exercices est ce que j’utilise chaque jour. Équilibres, pivots, sauts, travail aux engins : tout est classé par objectif et par niveau, avec les variantes et les corrections. Mes gymnastes sentent que chaque entraînement a une direction précise et leurs progrès techniques sont visibles.',
  author: 'Sophie Lambert',
  role: 'Entraîneure section compétition, 44 ans',
  location: 'Bordeaux, Nouvelle-Aquitaine'
}, {
  text: 'Le module de préparation aux compétitions a changé ma saison. Les dernières semaines sont planifiées, les simulations sont structurées et les listes de vérification m’évitent d’oublier des détails sous la pression. J’ai abordé les championnats régionaux beaucoup plus calme que les années précédentes.',
  author: 'Manon Girard',
  role: 'Entraîneure équipe d’ensemble, 31 ans',
  location: 'Strasbourg, Grand Est'
}, {
  text: 'Je gère une petite association et l’administratif était mon cauchemar : fiches individuelles, suivis, évaluations. Les documents d’évaluation et de suivi m’ont donné des modèles professionnels à personnaliser. Les familles reçoivent des bilans clairs et l’image de notre travail a énormément progressé.',
  author: 'Émilie Roussel',
  role: 'Responsable technique d’association, 46 ans',
  location: 'Nantes, Pays de la Loire'
}, {
  text: 'Les bonus sur les séquences techniques et sur les échauffements valent à eux seuls le prix du système. J’ai des protocoles complets d’activation et de récupération, et des ateliers déjà organisés par objectif. Je prépare beaucoup moins et je corrige beaucoup plus mes gymnastes pendant la séance.',
  author: 'Julie Marchand',
  role: 'Professeure en école et cours privés, 29 ans',
  location: 'Paris, Île-de-France'
}];
export function Testimonials() {
  return <section className="py-4 px-4 sm:px-6 bg-brand-cream border-y-2 border-brand-pink" data-id="element-136" data-mp="1ejeknqy8nwsm">
      <div className="text-center mb-3" data-id="element-137" data-mp="19rwjb1sazu74">
        <h2 className="font-display text-3xl sm:text-5xl tracking-wide text-brand-violet leading-none uppercase" data-id="element-138" data-mp="19qvbr7ahxpu5">
          Ce que disent les professeurs
        </h2>
        <p className="text-[11px] font-heading font-bold text-brand-magenta uppercase tracking-widest" data-id="element-139" data-mp="10sjambc079ng">
          Avis vérifiés
        </p>
      </div>
      <div className="flex flex-col gap-2" data-id="element-140" data-mp="vuq23bn8a3k0">
        {testimonials.map(testimonial => <article key={testimonial.author} className="bg-white border border-brand-pink p-3 rounded-md shadow-sm" data-id="element-141" data-mp="qvnaou067vui">
            <div className="flex gap-0.5 mb-1" data-id="element-142" data-mp="32ja32z84q8p9">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-143" data-mp="37htomyit9ih3" />)}
            </div>
            <p className="text-brand-slate font-medium italic text-xs sm:text-sm leading-snug" data-id="element-144" data-mp="3gh6y3r6xq71t">
              &laquo; {testimonial.text} &raquo;
            </p>
            <div className="border-t border-brand-pink pt-1.5 mt-1.5 flex gap-2 items-center" data-id="element-145" data-mp="2jobjtm8p3fk8">
              <div className="w-8 h-8 rounded-full bg-brand-pink text-brand-violet font-bold text-sm flex items-center justify-center shrink-0" data-id="element-146" data-mp="2oneoh5krjjro">
                {testimonial.author.charAt(0)}
              </div>
              <div data-id="element-147" data-mp="2xjnjm81pjw80">
                <p className="font-bold text-brand-violet text-xs" data-id="element-148" data-mp="210g9ydg7elwe">— {testimonial.author}</p>
                <p className="text-[10px] text-brand-slate font-bold uppercase tracking-wide leading-tight" data-id="element-149" data-mp="2519zfb9ao8re">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}